import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../Services/Api";

const ProtectedRoute = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/admin" />;
};

export default ProtectedRoute;
